export default {
  // list
  'container_transport_order_detail.column.orderId': '托单ID',
  'container_transport_order_detail.column.ladingOrderId': '提单ID',
  'container_transport_order_detail.column.transportOrderId': '运输单ID',
  'container_transport_order_detail.column.orderCargoId': '订单货物ID',
  'container_transport_order_detail.column.orderCargoDetailId': '订单货物明细ID',
  'container_transport_order_detail.column.cargoQty': '数量',
  'container_transport_order_detail.column.cargoWeight': '吨位',
  'container_transport_order_detail.column.loadingPoint': '装货地',
  'container_transport_order_detail.column.unloadingPoint': '卸货地',
  'container_transport_order_detail.column.transportToolName': '车船名称',
  'container_transport_order_detail.column.trainNumber': '船/车次号',
  'container_transport_order_detail.column.startTime': '起运时间',
  'container_transport_order_detail.column.endTime': '到达时间',
  'container_transport_order_detail.column.etdTime': '预到达时间',
  'container_transport_order_detail.column.createBy': '创建人',
  'container_transport_order_detail.column.updateBy': '更新人',
  'container_transport_order_detail.column.createTime': '创建时间',
  'container_transport_order_detail.column.updateTime': '更新时间',
  'container_transport_order_detail.column.dataSource': '数据来源',
  'container_transport_order_detail.column.remark': '备注',
  'container_transport_order_detail.column.status': '状态',
  // edit
  'container_transport_order_detail.edit.title': '编辑集装箱运输单明细',
  'container_transport_order_detail.add.title': '新增集装箱运输单明细',
  'container_transport_order_detail.edit.success': '编辑成功',
  'container_transport_order_detail.add.success': '新增成功',
  'container_transport_order_detail.form.orderId.required': '托单ID不能为空',
  'container_transport_order_detail.form.ladingOrderId.required': '提单ID不能为空',
  'container_transport_order_detail.form.transportOrderId.required': '运输单ID不能为空',
  'container_transport_order_detail.form.orderCargoId.required': '订单货物ID不能为空',
  'container_transport_order_detail.form.orderCargoDetailId.required': '订单货物明细ID不能为空',
  'container_transport_order_detail.form.cargoQty.required': '数量不能为空',
  'container_transport_order_detail.form.cargoWeight.required': '吨位不能为空',
  'container_transport_order_detail.form.loadingPoint.required': '装货地不能为空',
  'container_transport_order_detail.form.unloadingPoint.required': '卸货地不能为空',
  'container_transport_order_detail.form.transportToolName.required': '车船名称不能为空',
  'container_transport_order_detail.form.trainNumber.required': '船/车次号不能为空',
  'container_transport_order_detail.form.orderId': '托单ID',
  'container_transport_order_detail.form.orderId.placeholder': '请输入托单ID',
  'container_transport_order_detail.form.ladingOrderId': '提单ID',
  'container_transport_order_detail.form.ladingOrderId.placeholder': '请输入提单ID',
  'container_transport_order_detail.form.transportOrderId': '运输单ID',
  'container_transport_order_detail.form.transportOrderId.placeholder': '请输入运输单ID',
  'container_transport_order_detail.form.orderCargoId': '订单货物ID',
  'container_transport_order_detail.form.orderCargoId.placeholder': '请输入订单货物ID',
  'container_transport_order_detail.form.orderCargoDetailId': '订单货物明细ID',
  'container_transport_order_detail.form.orderCargoDetailId.placeholder': '请输入订单货物明细ID',
  'container_transport_order_detail.form.cargoQty': '数量',
  'container_transport_order_detail.form.cargoQty.placeholder': '请输入数量',
  'container_transport_order_detail.form.cargoWeight': '吨位',
  'container_transport_order_detail.form.cargoWeight.placeholder': '请输入吨位',
  'container_transport_order_detail.form.loadingPoint': '装货地',
  'container_transport_order_detail.form.loadingPoint.placeholder': '请输入装货地',
  'container_transport_order_detail.form.unloadingPoint': '卸货地',
  'container_transport_order_detail.form.unloadingPoint.placeholder': '请输入卸货地',
  'container_transport_order_detail.form.transportToolName': '车船名称',
  'container_transport_order_detail.form.transportToolName.placeholder': '请输入车船名称',
  'container_transport_order_detail.form.trainNumber': '船/车次号',
  'container_transport_order_detail.form.trainNumber.placeholder': '请输入船/车次号',
  'container_transport_order_detail.form.startTime': '起运时间',
  'container_transport_order_detail.form.startTime.placeholder': '请输入起运时间',
  'container_transport_order_detail.form.endTime': '到达时间',
  'container_transport_order_detail.form.endTime.placeholder': '请输入到达时间',
  'container_transport_order_detail.form.etdTime': '预到达时间',
  'container_transport_order_detail.form.etdTime.placeholder': '请输入预到达时间',
}
